import { Fragment, type ReactNode, useEffect } from 'react';
import { useLocale } from '../shared/i18n/useLocale.js';

/**
 * Tilni ilova daraxtiga ulaydi.
 *
 * `t()` — oddiy funksiya, hook emas: u chaqirilgan joyda 538 marta yozilgan va
 * ularning hech biri tilga obuna bo'lmagan. Shuning uchun til almashganda
 * yagona ishonchli yo'l — daraxtni **qayta ulash**: `key` o'zgarsa React butun
 * ostki daraxtni yangidan chizadi va `useMemo` ichida ushlanib qolgan
 * tarjimalar ham yangilanadi.
 *
 * Provider `QueryClientProvider` va `ToastProvider` dan PASTDA turadi: so'rov
 * keshi va bildirishnomalar til bilan birga tashlanmasligi kerak.
 */
export const LocaleProvider = ({ children }: { children: ReactNode }) => {
  const locale = useLocale();

  // Ekran o'quvchi va brauzerning imlo tekshiruvi hujjat tilini shu atributdan
  // biladi — til almashganda u ham almashishi kerak.
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return <Fragment key={locale}>{children}</Fragment>;
};
